import { tss } from 'tss-react/mui';
import { useRef } from 'react';

import { Or2Container } from '../layout/Or2Container';

import { AppDrawer } from './AppDrawer';
import { CommonHeader } from './CommonHeader';

const drawerWidth = 240;

const useStyles = tss.create(({ theme }) => {
  return {
    appLayout: {
      display: 'flex',
      flex: '1 1 0%',
      minHeight: 0,
      position: 'relative',
      overflow: 'hidden',
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      minWidth: 0,
      // Keep the scrollbar gutter stable as pages change, without fixing the
      // navigation to the viewport outside this layout.
      overflowY: 'scroll',
      paddingBottom: theme.spacing(6),
    },
    stickyContainer: {
      position: 'sticky',
      top: 0,
      zIndex: 1000,
    },
  };
});

interface MenuUser {
  _id: string | null | undefined;
  baseImage: string | null | undefined;
  firstName: string | null | undefined;
  lastName: string | null | undefined;
}

interface Props {
  user: MenuUser | null | undefined;
  loading: boolean;
  smallScreenDrawerOpen: boolean;
  largeScreenDrawerOpen: boolean;
  onToggleDrawer: () => void;
  onSignout: () => void;
  children: React.ReactNode;
}

export const MainMenu = ({
  user,
  loading,
  smallScreenDrawerOpen,
  largeScreenDrawerOpen,
  onToggleDrawer,
  onSignout,
  children,
}: Props) => {
  const { classes } = useStyles();
  const appLayoutRef = useRef<HTMLDivElement>(null);

  return (
    <div className={classes.appLayout} ref={appLayoutRef}>
      <AppDrawer
        containerRef={appLayoutRef}
        drawerWidth={drawerWidth}
        smallScreenDrawerOpen={smallScreenDrawerOpen}
        largeScreenDrawerOpen={largeScreenDrawerOpen}
        onToggleDrawer={onToggleDrawer}
      />
      <div className={classes.container}>
        <Or2Container mainContent={false} className={classes.stickyContainer}>
          <CommonHeader
            smallScreenDrawerOpen={smallScreenDrawerOpen}
            largeScreenDrawerOpen={largeScreenDrawerOpen}
            loading={loading}
            user={user}
            onSignout={onSignout}
            onToggleDrawer={onToggleDrawer}
          />
        </Or2Container>
        {children}
      </div>
    </div>
  );
};
